import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select';
import * as moment from 'moment';
import { FieldArray, Form, Formik } from "formik";

import {
  getBuyBackEmptyFormData,
  getBuyBackFeeFormInitialValues,
  VALIDATION_SCHEMA,
} from "web/components/utils/buyBackFeeFormsUtils";
import DropDown from "web/components/DropDown";
import Button from "web/components/Button";
import DatePicker from "web/components/DatePicker";
import NumberInput from "web/components/form-elements/NumberInput";
import Textarea from "web/components/form-elements/TextArea";
import AddPlusIcon from "web/assets/svg/PtPlusUserAddPlusIcon";
import DeleteIcon from "web/assets/svg/PtPlusUserDeleteIcon";
import { palletTypeOptions } from "../Constants";
import { FormWrapper, ItemsRowsWrapper, TableFormRowWrapper } from "../BuyBackFeeStyled";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ptPlusBuyBackSaveData } from "redux/actions/adminPTPlusBuyBackFee";

const AddBuyBackCustomerForm = ({
  customerMainLocationList,
  customerSubLocationList,
  getCustomerSubLocationList,
  vendorLocationList,
  setModalContent,
  setModalLink,
  toggleModal,
  setAlertType
}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [showLoopItemSection, setShowLoopItemsSection] = useState(false);

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
  }, []);

  const formSubmit = async (formProps) => {
    //map data for payload
    const itemsData = Object.values(formProps?.values?.buyBackFormData?.reduce((acc, item) => {
      const { vendorLocationId, vendorLocationName, city, state, ...rest } = item;
      if (!acc[vendorLocationId]) {
        acc[vendorLocationId] = { vendorLocationId, vendorLocationName, city, state, feeDetailsReq: [] };
      }
      if (!acc[vendorLocationId].feeDetailsReq) {
        acc[vendorLocationId].feeDetailsReq = [];
      }
      rest.rateStartDate = moment(rest.rateStartDate, "MM/DD/YYYY").format("YYYY-MM-DD");
      rest.rateExpirationDate = moment(rest.rateExpirationDate, "MM/DD/YYYY").format("YYYY-MM-DD");
      acc[vendorLocationId].feeDetailsReq.push(rest);
      return acc;
    }, {}));

    let postData = {
      customerLocationId: formProps?.values?.customerLocationId, //customer location Id
      mainLocationName: formProps?.values?.mainLocationName, // customer name
      mainLocationId: formProps?.values?.customerName,//customer id
      vendorPricing: itemsData
    }
    try {
      let response = await dispatch(ptPlusBuyBackSaveData(postData));
      if (response && response?.success) {
        setShowLoopItemsSection(false)
        formProps.resetForm();
        formProps.setValues(getBuyBackFeeFormInitialValues());
        setModalContent(response?.msg || response?.data?.msg)
        setAlertType("success")
        setModalLink("");
        toggleModal();
      } else {
        if (response?.statusCode === 401) {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response?.error?.message || response?.data?.error?.message)
          setModalLink("");
          toggleModal();
        }
      }
    } catch (error) {
      setModalContent(error || 'Something went wrong, please try again!')
      setModalLink("");
      toggleModal();
    }
  }


  const updateFieldValue = (setFieldValue, formValues, index, key, value) => {
    let cValue = formValues.buyBackFormData;
    if (key === 'rateStartDate' || key === 'rateExpirationDate') {
      const formattedDate = moment(value, 'MM/DD/YYYY').format('MM/DD/YYYY');
      cValue[index][key] = formattedDate;
    } else if (key === 'vendorFee' || key === 'customerFee') {
      cValue[index][key] = parseFloat(value);
    } else {
      cValue[index][key] = value;
    }
    setFieldValue('buyBackFormData', cValue);
  }



  return (
    <>
      <Formik
        initialValues={getBuyBackFeeFormInitialValues()}
        validationSchema={VALIDATION_SCHEMA()}
        onSubmit={formSubmit}
      >
        {(formikProps) => {
          const { isValid, dirty, setFieldValue, values, errors, setFieldError } = formikProps;
          const isAddButtonDisabled = !values.customerName || !values.customerLocationId;
          const isSubmitButtonDisabled = !isValid || !dirty || !values.buyBackFormData.length;
          return <>
            <Form className="form-wrapper">
              <FormWrapper>
                <div>
                  <TableFormRowWrapper>

                    {/* Meta for Form */}
                    <div className="row mb-1">
                      <div className="col-md-4">
                        <DropDown
                          label="Customer Name"
                          placeholder="Customer Name"
                          name="customerName"
                          searchDropDown={values.customerName}
                          searchable={true}
                          data={customerMainLocationList}
                          onChangeHandler={async (value) => {
                            await getCustomerSubLocationList(value.value);
                            setFieldValue("customerLocationId", "");
                            setFieldValue("customerName", value.value);
                            setFieldValue("mainLocationName", value.label);
                          }}
                        />
                      </div>

                      <div className="col-md-4">
                        <DropDown
                          label="Customer Location Name"
                          placeholder="Customer Location Name"
                          name="customerLocationId"
                          searchDropDown={values.customerLocationId}
                          searchable={true}
                          data={customerSubLocationList}
                          onChangeHandler={async (value) => {
                            setFieldValue("customerLocationId", value.value);
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                          <button type="button" disabled={isAddButtonDisabled} className="add-buyback-fee" onClick={() => setShowLoopItemsSection(!showLoopItemSection)}><AddPlusIcon />Add Buyback Fee</button>
                        </div>
                      </div>
                    </div>

                    {/* Loops are below */}
                    {showLoopItemSection && (
                      <>
                        <ItemsRowsWrapper>
                          <div className="row mb-2">
                            <div className="col-md-12">
                              <div className="items-row-wrapper grid-view">
                                <div className="label-heading">
                                  <p>Buyback Vendor<span className="star">*</span></p>
                                </div>
                                <div className="label-heading">
                                  <p>Pallet Type<span className="star">*</span></p>
                                </div>
                                <div className="label-heading">
                                  <p>Customer price<span className="star">*</span></p>
                                </div>
                                <div className="label-heading">
                                  <p>Vendor price<span className="star">*</span></p>
                                </div>
                                <div className="label-heading">
                                  <p>Start Date<span className="star">*</span></p>
                                </div>
                                <div className="label-heading">
                                  <p>End Date<span className="star">*</span></p>
                                </div>
                                <div className="label-heading">
                                  <p>Comment</p>
                                </div>
                              </div>

                              <FieldArray name="buyBackFormData">
                                {({ insert, remove, push }) => (
                                  <div>
                                    {
                                      values.buyBackFormData.length > 0 &&
                                      values.buyBackFormData.map((currentRow, index) => (
                                        <div
                                          className="items-row-wrapper grid-view"
                                          key={`adding-new-${index}`}
                                        >
                                          <div className="mb-2">
                                            <Select
                                              id="vendorLocationId"
                                              name={`buyBackFormData.[${index}].vendorLocationId`}
                                              value={values.buyBackFormData[index].vendorLocationId ? vendorLocationList.find(option => option.value === currentRow.vendorLocationId) : null}
                                              onChange={(selectedOption) => {
                                                updateFieldValue(setFieldValue, values, index, "vendorLocationId", selectedOption.value);
                                                updateFieldValue(setFieldValue, values, index, "vendorLocationName", selectedOption.vendorLocationName);
                                                updateFieldValue(setFieldValue, values, index, "city", selectedOption.city);
                                                updateFieldValue(setFieldValue, values, index, "state", selectedOption.state);
                                              }}
                                              options={vendorLocationList}
                                              placeholder="Buyback vendor"
                                            />
                                          </div>
                                          <div className="mb-2">
                                            <Select
                                              id="pickupPalletType"
                                              name={`buyBackFormData.[${index}].pickupPalletType`}
                                              value={values.buyBackFormData[index].pickupPalletType ? palletTypeOptions.find(option => option.value === currentRow.pickupPalletType) : null}
                                              onChange={(selectedOption) => {
                                                updateFieldValue(setFieldValue, values, index, "pickupPalletType", selectedOption.value);
                                              }}
                                              options={palletTypeOptions}
                                              placeholder="Pallet Type"
                                            />
                                          </div>

                                          <div className="mb-2">
                                            <NumberInput
                                              name={`buyBackFormData.[${index}].customerFee`}
                                              showErrorMessages={true}
                                              decimalScale={2}
                                              placeholder="$ 0.00"
                                              maxLength={8}
                                              onChangeHandler={(val) => {
                                                updateFieldValue(setFieldValue, values, index, "customerFee", val);
                                              }}
                                            />
                                          </div>

                                          <div className="mb-2">
                                            <NumberInput
                                              name={`buyBackFormData.[${index}].vendorFee`}
                                              showErrorMessages={true}
                                              decimalScale={2}
                                              placeholder="$ 0.00"
                                              maxLength={8}
                                              onChangeHandler={(val) => {
                                                updateFieldValue(setFieldValue, values, index, "vendorFee", val);
                                              }}
                                            />
                                          </div>

                                          <div className="mb-2 position-relative ">
                                            <DatePicker
                                              name={`buyBackFormData.[${index}].rateStartDate`}
                                              maxDOBirth={currentRow.rateExpirationDate}
                                              value={currentRow.rateStartDate}
                                              type="buyBackFeeForm"
                                              callBackFun={(date, value) => {
                                                updateFieldValue(setFieldValue, values, index, "rateStartDate", moment(date).format("MM/DD/YYYY"));
                                              }}
                                            />
                                            {errors.buyBackFormData && errors.buyBackFormData[index] && errors.buyBackFormData[index].rateStartDate && (
                                              <p className="error-message">{errors.buyBackFormData[index].rateStartDate}</p>
                                            )}
                                          </div>

                                          <div className="mb-2 position-relative ">
                                            <DatePicker
                                              name={`buyBackFormData.[${index}].rateExpirationDate`}
                                              minDOBirth={currentRow.rateStartDate}
                                              value={currentRow.rateExpirationDate}
                                              type="buyBackFeeForm"
                                              callBackFun={(date, value) => {
                                                updateFieldValue(setFieldValue, values, index, "rateExpirationDate", moment(date).format("MM/DD/YYYY"));
                                              }}
                                            />
                                            {errors.buyBackFormData && errors.buyBackFormData[index] && errors.buyBackFormData[index].rateExpirationDate && (
                                              <p className="error-message">{errors.buyBackFormData[index].rateExpirationDate}</p>
                                            )}
                                          </div>

                                          <div className="mb-2">
                                            <Textarea
                                              name={`buyBackFormData.[${index}].comment`}
                                              showErrorMessages={true}
                                              rows={1}
                                              onChange={(val) => {
                                                updateFieldValue(setFieldValue, values, index, "comment", val);
                                              }}

                                            />
                                          </div>

                                          <div className="mb-2">
                                            {((values.buyBackFormData.length - 1) === index) ?
                                              <button
                                                className="add-more"
                                                type="button"
                                                onClick={() => {
                                                  if (values.buyBackFormData.length < 5) {
                                                    push({ ...getBuyBackEmptyFormData() });
                                                  } else {
                                                    // alert("You can only add up to 5 items.");
                                                    setModalContent("You can only add up to 5 items.")
                                                    setModalLink("");
                                                    toggleModal();
                                                  }
                                                }}
                                              >
                                                <AddPlusIcon />
                                              </button>
                                              : <button className="add-more remove" type="button"
                                                onClick={() => {
                                                  const updatedFormValues = [...values.buyBackFormData];
                                                  updatedFormValues.splice(index, 1, getBuyBackEmptyFormData());
                                                  setFieldValue('buyBackFormData', updatedFormValues);
                                                  remove(index);
                                                }}
                                              >
                                                <DeleteIcon />
                                              </button>
                                            }
                                          </div>

                                        </div>
                                      ))
                                    }

                                  </div>
                                )}
                              </FieldArray>

                            </div>
                          </div>
                          <div className="row">
                            <Button
                              type="app-green-button"
                              handleClick={() => formSubmit(formikProps)}
                              disabled={isSubmitButtonDisabled}
                            >
                              Submit
                            </Button>
                          </div>
                        </ItemsRowsWrapper>
                      </>
                    )}
                  </TableFormRowWrapper>
                </div>
              </FormWrapper>
            </Form>
          </>
        }}
      </Formik>
    </>
  )
}

export default AddBuyBackCustomerForm
